import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import coversheetfooter from "../../images/Export/ischebeck-export-deckblatt.jpg";
import footer from "../../images/Export/ischebeck-export-footer.jpg";
import logo from "../../images/logo.png";
import { BemessungenMikropfaehle } from "../../store/slices/bemessungenMikropfaehleSlice";
import { AASHTO } from "./Aashto/AASHTO";
import Coversheet from "./Coversheet";
import { Germany } from "./EurocodeGermany/Germany";
import { FHWA } from "./FHWA/FHWA";

// Create styles
export const styles = StyleSheet.create({
  document: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  pageTitle: {
    fontSize: 12,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  // Decorative footer image behind the page number. left: 0 anchors it to the
  // page's left edge; without it the footer View's paddingLeft insets the image
  // and leaves a white strip down the left of every content page.
  footerBackground: {
    position: "absolute",
    width: 700,
    bottom: 0,
    left: 0,
  },
  section: {
    margin: 10,
    padding: 0,
    flexGrow: 1,
    color: "black",
  },

  sectionText: {
    margin: 10,
    paddingLeft: 10,
    flexGrow: 1,
    fontSize: 9,
  },
  sectionSubText: {
    marginTop: 20,
    marginBottom: 0,
    marginLeft: 10,
    marginRight: 10,
    color: "black",
    flexGrow: 1,
    fontSize: 14,
  },
  sectionSubText2: {
    margin: 10,
    color: "#000",
    flexGrow: 1,
    fontSize: 10,
  },
  sectionSubText3: {
    marginHorizontal: 10,
    marginVertical: 3,
    color: "#000",
    flexGrow: 1,
    fontSize: 8,
  },
  pageWrapper: {
    padding: 15,
    position: "absolute",
  },
  coversheet: {
    position: "absolute",
    justifyContent: "space-around",
    color: "white",
    fontSize: 30,
    marginBottom: 60,
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    fontSize: 8,
    margin: 10,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    height: 20,
    textAlign: "center",
    fontWeight: "bold",
    flexGrow: 1,
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 24,
    fontWeight: "bold",
  },
  title: {
    width: "50%",
    textAlign: "left",
    paddingLeft: 8,
  },
  bez: {
    width: "10%",
    textAlign: "right",
    paddingRight: 8,
  },
  bezimage: {
    width: "20pt",
    height: "8pt",
  },
  unit: {
    width: "10%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "left",
  },
  value: {
    width: "10%",
    // borderRightColor: borderColor,
    // borderRightWidth: 1,
    textAlign: "left",
  },
  formula: {
    width: "20%",
    textAlign: "right",
    //paddingRight: 8,
  },
  formulaimage: {
    height: 7,
    textAlign: "right",
    paddingRight: 10,
  },
});

export const tableStyles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 5,
    //borderWidth: 1,
    //borderColor: "#bff0fd",
    fontSize: 8,
    //margin: 10,
  },
});

export const tableRowStyles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 0.3,
    borderBottomColor: "black",
    height: 24,
    fontStyle: "normal",
    marginLeft: 10,
    marginRight: 0,
  },
  rowInfoText: {
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 0.3,
    borderBottomColor: "black",
    height: 24,
    fontStyle: "normal",
    marginLeft: 10,
    marginRight: 0,
  },

  title: {
    width: "45%",
    textAlign: "left",
    paddingLeft: 0,
  },
  textTitle: {
    width: "100%",
    textAlign: "left",
    //paddingLeft: 8,
  },
  bez: {
    width: "10%",
    textAlign: "right",
    alignContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 8,
  },
  bezimage: {
    width: "40pt",
    height: "8pt",
  },
  unit: {
    width: "7%",
    textAlign: "left",
  },
  value: {
    width: "15%",
    textAlign: "center",
  },
  formula: {
    width: "23%",
    textAlign: "left",
  },
  formulaimage: {
    height: 7,
    textAlign: "left",
    paddingRight: 10,
  },
  treewayvalue_one: {
    width: "40%",
    textAlign: "center",
  },
  treewayvalue_two: {
    width: "40%",
    textAlign: "center",
  },
  treewayvalue_one_image: {
    width: "40%",
    textAlign: "center",
    alignItems: "center",
  },
  treewayvalue_two_image: {
    width: "40%",
    textAlign: "center",
    alignItems: "center",
  },
  treewayvalue_sign: {
    width: "10%",
    textAlign: "center",
    alignItems: "center",
  },
  treewayvalue_unit: {
    width: "10%",
    textAlign: "left",
  },
});

const Header = (props) => {
  return (
    <View
      fixed
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        //border: "1 solid #000",
        minHeight: 50,
        fontSize: 7,
      }}
    >
      {/* <View> */}
      <Image
        src={logo}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          width: 75,
          height: 35,
        }}
      />
    </View>
  );
};

const Footer = ({ Deckblatt }) => {
  const { t, i18n } = useTranslation("translation");

  if (!Deckblatt || !Deckblatt.PreparedBy) {
    return (
      <View
        fixed
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          paddingBottom: 30,
          paddingLeft: 30,
          fontSize: 8,
        }}
      >
        <Image src={footer} style={styles.footerBackground} />
        <Text style={{ width: "65%" }}>{t("deckblatt.Prepared by")}: -</Text>
        <Text style={{ width: "20%" }}>ischebeck.de</Text>
        <Text
          style={{
            width: "15%",
          }}
          render={({ pageNumber, totalPages }) => {
            return `${pageNumber} / ${totalPages}`;
          }}
        />
      </View>
    );
  }

  return (
    <View
      fixed
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        left: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        paddingBottom: 30,
        paddingLeft: 30,
        fontSize: 8,
      }}
    >
      <Image src={footer} style={styles.footerBackground} />
      <Text style={{ width: "65%" }}>
        {Deckblatt.PreparedBy?.company} | {t("deckblatt.Prepared by")}:{" "}
        {Deckblatt.PreparedBy?.username}
      </Text>
      <Text style={{ width: "20%" }}>ischebeck.de | {Deckblatt.PreparedBy?.createdAt}</Text>
      <Text
        style={{
          width: "15%",
        }}
        render={({ pageNumber, totalPages }) => {
          return `${pageNumber} / ${totalPages}`;
        }}
      />
    </View>
  );
};

export const PageWrapper = (props) => {
  const { Deckblatt } = props;
  return (
    <Page size="A4" style={styles.pageWrapper}>
      <Header Deckblatt={Deckblatt} />
      <Footer Deckblatt={Deckblatt} />
      {props.children}
    </Page>
  );
};

// Create Document Component
const SmartTitanProjektPDF = ({ data, settings }) => {
  const { t } = useTranslation("translation");
  const hasTitle = data.Deckblatt.Project?.title !== "";
  const hasSubTitle = data.Deckblatt.Project?.subtitle !== "";
  const bemessungenMikropfaehle = data.Deckblatt.BemessungenMikropfaehle;
  const ttext =
    bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
      ? t("deckblatt.eurocode")
      : bemessungenMikropfaehle === BemessungenMikropfaehle.GERMANY
        ? t("deckblatt.germany")
        : bemessungenMikropfaehle === BemessungenMikropfaehle.AASHTO
          ? t("deckblatt.aashto")
          : t("deckblatt.fhwa");

  return (
    <Document>
      <Coversheet Deckblatt={data.Deckblatt}>
        <View
          style={{
            height: "100%",
            color: "black",
          }}
        >
          <Image
            src={logo}
            style={{
              position: "absolute",
              top: 30,
              right: 20,
              width: 140,
            }}
          />
          <Image
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              height: 250,
            }}
            src={coversheetfooter}
          />
          <Text
            style={{
              position: "absolute",
              bottom: 70,
              fontSize: 14,
              paddingLeft: 50,
            }}
          >
            {t("deckblatt.smartTitan")}
          </Text>
          <Text
            style={{
              position: "absolute",
              bottom: 50,
              fontSize: 14,
              paddingLeft: 50,
            }}
          >
            {t("deckblatt.slogan")}
          </Text>
          <Text style={{ paddingTop: 175, paddingLeft: 50, fontWeight: "normal" }}>
            {t("deckblatt.headline_pdf")}
          </Text>
          <Text
            style={{
              paddingTop: 20,
              paddingLeft: 50,
              fontSize: 18,
              fontWeight: "normal",
            }}
          >
            {ttext}
          </Text>

          <View style={{ marginHorizontal: 50, marginTop: 30 }}></View>
          <Text
            style={{
              paddingTop: 30,
              paddingLeft: 50,
              fontWeight: "extrabold",
              fontSize: 15,
            }}
          >
            {hasTitle ? data.Deckblatt.Project?.title : ""}
          </Text>

          <Text
            style={{
              paddingTop: 20,
              paddingLeft: 50,
              fontWeight: "extrabold",
              fontSize: 12,
            }}
          >
            {hasSubTitle ? data.Deckblatt.Project?.subtitle : ""}
          </Text>

          {data.Deckblatt.LogoImageUrl !== "" && data.Deckblatt.LogoImageUrl !== undefined && (
            <View style={{ marginHorizontal: 50, marginTop: 80 }}>
              <Image
                style={{
                  width: "150px",
                }}
                source={data.Deckblatt.LogoImageUrl}
              />
            </View>
          )}
          <Text
            style={{
              paddingTop: 20,
              paddingLeft: 50,
              fontWeight: "extrabold",
              fontSize: 12,
            }}
          >
            {t("deckblatt.userCompany")} {data.Deckblatt.PreparedBy?.company}
          </Text>
          <Text
            style={{
              paddingTop: 10,
              paddingLeft: 50,
              fontWeight: "extrabold",
              fontSize: 12,
            }}
          >
            {t("deckblatt.createdByUser")} {data.Deckblatt.PreparedBy?.username}
          </Text>
        </View>
      </Coversheet>

      {data.Deckblatt.Project?.text !== "" && (
        <PageWrapper Deckblatt={data.Deckblatt}>
          <View>
            <Text style={{ paddingLeft: 40, fontSize: 18, paddingTop: 10 }}>
              {t("deckblatt.projectDescription")}
            </Text>
            <Text
              style={{
                paddingTop: 10,
                paddingLeft: 40,
                paddingRight: 40,
                fontSize: 12,
              }}
            >
              {data.Deckblatt.Project.text}
            </Text>
          </View>
        </PageWrapper>
      )}

      {bemessungenMikropfaehle == "1" || bemessungenMikropfaehle == "0" ? (
        <Germany data={data} settings={settings} />
      ) : null}
      {bemessungenMikropfaehle == "2" ? <AASHTO data={data} settings={settings} /> : null}
      {bemessungenMikropfaehle == "3" ? <FHWA data={data} settings={settings} /> : null}

      {/* <EDPCalculator data={data} settings={settings}/> */}
    </Document>
  );
};

export default SmartTitanProjektPDF;
